var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	<i class=\"quit-reason\">("
    + ((stack1 = __default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/parse.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + ")</i>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("/home/travis/build/thelounge/lounge/client/views/user_name.tpl"),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<i class=\"hostmask\">("
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.hostmask : depth0), depth0))
    + ")</i>\nhas quit\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/actions/quit.tpl
// module id = 226
// module chunks = 0